export const questionnaire_AI = {
    name: '問卷 A-1',
    subtitle: '請根據本學期平時的閱讀與中文寫作經驗回答，包括課堂內外的經驗，不限定紙本或網上材料。',
    sections: [
        [
            {
                id: 'A',
                title: 'A　閱讀動機',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我喜歡閱讀。' },
                    { question: '閱讀讓我感到愉快。' },
                    { question: '我覺得閱讀很有意思。' },
                    { question: '我認為閱讀是一件有意義的事。' },
                    { question: '我覺得閱讀對自己有用。' },
                    { question: '閱讀對我很重要。' },
                    { question: '我會閱讀，是因為不閱讀會讓我感到內疚。' },
                    { question: '我會閱讀，是因為別人期望我這樣做。' },
                    { question: '我會閱讀，是因為這樣可以得到別人的獎勵。' },
                ]
            },
        ],
        [
            {
                id: 'B',
                title: 'B　閱讀中的感受',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我常能從閱讀中獲得成就感。' },
                    { question: '我常常不太有信心理解讀到的內容。' },
                    { question: '我常覺得自己不擅長理解閱讀內容。' },
                    { question: '我覺得自己可以自由選擇想讀的內容。' },
                    { question: '與別人談論閱讀內容時，我能自在地表達自己的想法和意見。' },
                    { question: '選擇和談論閱讀內容時，我覺得可以做自己。' },
                    { question: '我身邊的人關心我的閱讀興趣。' },
                    { question: '與別人談論讀過的內容時，我覺得彼此很親近。' },
                    { question: '經常與我談論閱讀的人，似乎對我的想法不太感興趣。' }
                ]
            }],
        [
            {
                id: 'C',
                title: 'C　我怎樣看自己的閱讀與中文寫作',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我擅長閱讀。' },
                    { question: '閱讀對我來說很容易。' },
                    { question: '在中文課上，我比班上其他同學讀得更好。' },
                    { question: '我擅長用中文寫作。' },
                    { question: '用中文寫作對我來說很容易。' },
                    { question: '我用中文寫的故事比班上其他同學更好。' }
                ]
            },
        ],
        [
            {
                id: 'D',
                title: 'D　中文老師如何回應我的需要',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '中文老師經常讓我參與課堂上的決定。' },
                    { question: '中文老師讓我在課堂上做自己喜歡的活動。' },
                    { question: '當我希望中文課的活動有所改變時，老師會認真聆聽我的想法。' }
                ]
            }
        ],
        [
            {
                id: 'E',
                title: 'E　我如何向中文老師表達需要與意見',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '學習中文時，我會讓老師知道自己需要什麼、希望得到什麼。' },
                    { question: '中文課上，我會向老師表達自己的偏好和意見。' },
                    { question: '中文課上，如果有需要，我會向老師提出請求。' },
                    { question: '中文課上，我會向老師提出有助於自己學習的問題。' },
                    { question: '我會讓中文老師知道自己對哪些學習內容感興趣。' }
                ]
            },
        ],
        [
            {
                id: 'F',
                title: 'F　閱讀與中文寫作遇到困難時的反應',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '閱讀遇到困難時，我不會放棄。' },
                    { question: '用中文寫作時，即使遇到困難，我也不會放棄。' },
                    { question: '我會解決閱讀時遇到的問題。' },
                    { question: '用中文寫作時，我會努力解決遇到的問題。' },
                    { question: '閱讀時，我會努力解決遇到的問題。' },
                    { question: '中文課上，我會自己想出問題的答案。' }
                ]
            }
        ],
        [
            {
                id: 'G',
                title: 'G　我們的意見與中文課的安排',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我們在中文課上分享意見，老師會採用這些意見。' },
                    { question: '中文老師會根據我們的想法，決定課堂上做什麼活動。' },
                    { question: '班上的同學會向中文老師提出想法，老師會採用這些想法。' },
                    { question: '中文老師會徵詢我們的意見，以決定課堂上做什麼。' },
                    { question: '中文老師會聆聽我們關心的問題，並採取行動。' },
                    { question: '我們會向中文老師分享想法，老師會據此採取行動。' }
                ]
            }
        ]
    ]
}